import { RENTAL_CAR_VEHICLE_TYPE_CAR } from 'commons/js/constants'

export const defaultFilterBox = {
    fuelType: [],
    gearBox: '',
    distanceExtraKm: null,
    passengers: '',
    baggage: '',
}

export const getDefaultFilters = (initialFilters = {}) => updateFilters({
    ...defaultFilterBox,
    vehicleType: RENTAL_CAR_VEHICLE_TYPE_CAR,
    categoryList: [],
}, initialFilters)

export const cleanFilters = (filters) => updateFilters({}, {
    ...defaultFilterBox,
    vehicleType: filters.vehicleType,
    categoryList: [],
})

export const updateFilters = (prevFilters, filters) => ({
    fuelType: filters.fuelType || prevFilters.fuelType,
    gearBox: filters.gearBox || prevFilters.gearBox,
    passengers: filters.passengers || prevFilters.passengers,
    baggage: filters.baggage || prevFilters.baggage,
    distanceExtraKm: filters.distanceExtraKm || prevFilters.distanceExtraKm,
    vehicleType: filters.vehicleType || prevFilters.vehicleType,
    categoryList: filters.categoryList || prevFilters.categoryList,
})

const getCategoryList = (vehicleType, categoryList) => {
    if (categoryList && vehicleType === RENTAL_CAR_VEHICLE_TYPE_CAR) {
        return categoryList.join(',')
    }

    return ''
}

export const buildSearchParams = ({ search, filters }) => {
    const { startDate, endDate, age, idDestinationPOI, idOriginPOI, isMutuaUser } = search
    const { distanceExtraKm, baggage, passengers, fuelType, gearBox, vehicleType, categoryList } = filters
    return {
        start_date: startDate,
        end_date: endDate,
        age,
        idDestinationPOI,
        idOriginPOI,
        isMutuaUser,
        distanceExtraKm: distanceExtraKm || '',
        fuelType: (fuelType && fuelType.join(',')) || '',
        gearBox: gearBox || '',
        passengers: passengers || '',
        baggage: baggage || '',
        vehicleType: vehicleType || RENTAL_CAR_VEHICLE_TYPE_CAR,
        categoryList: getCategoryList(vehicleType || RENTAL_CAR_VEHICLE_TYPE_CAR, categoryList),
    }
}

export function parseFilters (params) {
    const { fuelType, gearBox, distanceExtraKm, passengers, baggage, vehicleType, categoryList } = params
    const filters = {
        fuelType: (fuelType && fuelType.split(',')) || '',
        gearBox: gearBox || '',
        distanceExtraKm: distanceExtraKm || '',
        passengers: passengers || '',
        baggage: baggage || '',
        vehicleType: vehicleType || RENTAL_CAR_VEHICLE_TYPE_CAR,
        categoryList: (categoryList && categoryList.split(',')) || [],
    }

    return filters
}

export const hasFilterSelected = (filters) => {
    const { fuelType, gearBox, distanceExtraKm, passengers, baggage } = filters

    return fuelType.length > 0 || !!gearBox || !!distanceExtraKm || !!passengers || !!baggage
}
